import {
    IMPORT_BOOKING_LIST,
    IMPORT_BOOKING_PAGINATION,
    IMPORT_BOOKING_SUMMARY,
    IMPORT_BOOKING_SUMMARY_INIT,
    IMPORT_BOOKING_CANCEL_LIST,
    IMPORT_BOOKING_CANCEL_PAGINATION,
    IMPORT_BOOKING_CANCEL_SUMMARY
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';

const logImportApiError = (label, error, payload) => {
    console.error(`❌ ${label} failed`, {
        url: error?.config?.url,
        method: error?.config?.method,
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        responseData: error?.response?.data,
        message: error?.message,
        payload,
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getImportBookingList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        const url = `/v1/Arrival_Import/GetArrivalNoticeList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                console.log("result", result)
                dispatch({
                    type: IMPORT_BOOKING_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: IMPORT_BOOKING_PAGINATION,
                    payload: result?.pagination || {},
                });
                dispatch({
                    type: IMPORT_BOOKING_SUMMARY,
                    payload: result?.summary || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 *  https://api.shipez.ai/api/v1/Booking/InactiveBookingByID?BookingId=12&ModifiedBy=admin
 * @param {*} payload 
 * @returns 
 */
export const deleteImportBookingDetails = (payload) => {
    const queryParams = new URLSearchParams({
        ...payload,
    }).toString();
    const url = `v1/Booking/InactiveBookingByID1?${queryParams}`;
    return APICall('Get', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getImportBookingList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getCancelBookingList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        const url = `v1/Booking/GetCancelledBookingList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: IMPORT_BOOKING_CANCEL_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: IMPORT_BOOKING_CANCEL_PAGINATION,
                    payload: result?.pagination || {},
                });
                dispatch({
                    type: IMPORT_BOOKING_CANCEL_SUMMARY,
                    payload: result?.summary || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getImportBookingDetails = (bookingId, companyid) => {
    return dispatch => {
        const url = `v1/Arrival_Import/GetArrivalNotice?BolID=${bookingId}&CompanyID=${companyid}`;

        return APICall('get', null, url).then(
            result => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    return result?.data;
                } else {
                    return Promise.reject(result);
                }
            },
            error => {
                return Promise.reject(error);
            }
        );
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const addImportBookingDetails = (payload) => {

    const url = `v1/Arrival_Import/InsertArrivalNotice`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getImportBookingList(payList);

            return result;

        } else {
            return false;
        }
    }, error => {
        logImportApiError('InsertArrivalNotice', error, payload);
        return Promise.reject(error);
    });
};


/**
 *  
 * @param {*} payload 
 * @returns 
 */
export const updateImportBookingDetails = (payload) => {
    const url = `v1/Arrival_Import/UpdateArrivalNotice`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getImportBookingList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        logImportApiError('UpdateArrivalNotice', error, payload);
        return Promise.reject(error);
    });
};







/**
 * 
 * @param {*} BookingId 
 * @returns 
 */
export const getImportStatusAuditDetails = (BookingId, CompanyID) => {
    return dispatch => {
        const url = `v1/Arrival_Import/GetImportStatusAudit?BolID=${BookingId}&CompanyID=${CompanyID}`;
        return APICall('get', null, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updateImportStatusAuditDetails = (payload) => {
    return dispatch => {
        const url = `v1/Arrival_Import/UpdateStatusAudit`;
        return APICall('post', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const updateDockReceipt = (payload) => {
    return dispatch => {
        const url = `v1/Booking/UpdateDocRecipt`;
        return APICall('post', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


export const getDockReceipt = (BookingId) => {
    return dispatch => {
        const url = `v1/Booking/GetDockReceipt?BookingId=${BookingId}`;
        return APICall('get', null, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const deleteImportBookingList = (payload) => {
    const url = `v1/Booking/DeleteBookingList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const reinstateBookingList = (payload) => {
    const url = `v1/Booking/ReinstateBookingList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};


//hanlde change for charge code dropdown in accounting invoice and bill page
export const getChargeCodes = (keyword = "", flag = 0) => {
    return async () => {
        const searchValue = keyword && keyword.trim() ? keyword : "o"; // ✅ no empty

        const url = `v1/Common/ChargesDescription_List?flag=${flag}&searchKeyword=${searchValue}`;

        const result = await APICall("get", {}, url);

        return result?.data || []; // ✅ your API already array
    };
};



/**
 * Import booking AR/AP sync (mirrors Export v1/Booking/SyncArAp).
 * @param {*} payload { bookingId, isSync, fclBolImpArCharges, fclBolImpApCharges }
 * @returns
 * https://api.shipez.ai/api/v1/Arrival_Import/ImportSyncArAp
 */
export const ImportSyncArAp = (payload) => {
    const url = `v1/Arrival_Import/ImportSyncArAp`;
    return APICall("post", payload, url).then(
        async (result) => {
            if (result?.statuscode === 201 || result?.statuscode === 200) {
                return result;
            }
            return false;
        },
        (error) => Promise.reject(error),
    );
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */

export const GetVesselSchedule = (payload) => {
    return dispatch => {
        // Convert object to query string for GET
        const params = new URLSearchParams(payload).toString();
        const url = `v1/FCLRateQuoteSearch/VesselSearch?${params}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * Get Arrival Notice List
 * @param {*} payload { BolID, CompanyID }
 */
export const getArrivalNoticeList = (payload) => {
    return (dispatch) => {
        const { BolID, CompanyID } = payload || {};

        const url = `v1/Arrival_Import/GetArrivalNotice?BolID=${BolID}&CompanyID=${CompanyID}`;

        return APICall("get", null, url)
            .then(
                (result) => {
                    if (result?.statuscode === 200 || result?.statuscode === 201) {
                        return result?.data;
                    } else {
                        return Promise.reject(result);
                    }
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
    };
};



/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const addReleaseOrderDetails = (payload) => {
    const url = `v1/Arrival_Import/InsertReleaseOrder`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {

            return result?.data;

        } else {
            return Promise.reject();
        }
    }, error => {
        return error;
    });
};



/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getReleaseOrderDetails = (bookingId, companyid) => {
    return dispatch => {
        const url = `v1/Arrival_Import/GetArrivalReleaseOrderDataById?bolID=${bookingId}&companyId=${companyid}`;
        return APICall('get', null, url).then(
            result => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    return result?.data ?? {}
                } else {
                    return Promise.reject(result);
                }
            },
            error => {
                return Promise.reject(error);
            }
        );
    };
};

/**
 * Fetch delivery order details by BOL ID and company ID
 *
 * @param {string|number} bookingId - Bill of Lading (BOL) ID
 * @param {string|number} companyid - Company ID
 * @returns {function} Redux thunk action that returns a Promise resolving to delivery order data
 */
export const getDeliveryOrderDetails = (bookingId, companyid) => {
    return dispatch => {
        const url = `v1/Arrival_Import/GetArrivalDeliveryOrderById?BolId=${bookingId}&CompanyId=${companyid}`;
        return APICall('get', null, url).then(
            result => {
                if (result?.statuscode === 200 || result?.statuscode === 201) {
                    return result?.data ?? {}
                } else {
                    return Promise.reject(result);
                }
            },
            error => {
                return Promise.reject(error);
            }
        );
    };
};



/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updateReleaseOrderDetails = (payload) => {
    return dispatch => {
        const url = `v1/Arrival_Import/UpdateReleaseOrder`;
        return APICall('post', payload, url).then(result => {
            console.log("api response result", result);

            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result;
            } else {
                return Promise.reject(result);
            }
        }).catch(error => {
            return Promise.reject(error);
        });
    };
};

/**
 * Makes an API call to update delivery order details.
 *
 * @param {Object} payload - The request data sent to the API.
 * @returns {Function} A Redux thunk function that receives dispatch and returns a Promise.
 * The Promise resolves with the API response if statuscode is 200 or 201,
 * otherwise it rejects with the error/response.
 */

export const updateDeliveryOrderDetails = (payload) => {
    return async (dispatch) => {
        const url = `v1/Arrival_Import/UpdateArrivalDeliveryOrder`;

        try {
            const result = await APICall('post', payload, url);
            console.log("api response result", result);

            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result;
            }

            throw result; // cleaner than Promise.reject
        } catch (error) {
            throw error; // no need for Promise.reject
        }
    };
};